// extracted by mini-css-extract-plugin
export default {"menuBlock":"KE-z","title":"LE-z","nav":"ME-z","flexCell":"NE-z","facetLink":"OE-z"};